import { render, staticRenderFns } from "./askOrder.vue?vue&type=template&id=427aeccd&scoped=true"
import script from "./askOrder.vue?vue&type=script&lang=js"
export * from "./askOrder.vue?vue&type=script&lang=js"
import style0 from "./askOrder.vue?vue&type=style&index=0&id=427aeccd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427aeccd",
  null
  
)

export default component.exports